export default __webpack_public_path__ + "static/media/snow-1-night.2a130249.svg";